"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ToEmailPill = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _ = _interopRequireWildcard(require("../"));
var _EmailPillInput = require("./EmailPillInput");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FROM_DEFALUT_TEXT = 'From';
function FromEmailPill(props, ref) {
  var contacts = props.contacts,
    getRecipientAvatar = props.getRecipientAvatar,
    onSelect = props.onSelect;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectContacts = _useState2[0],
    setSelectContacts = _useState2[1];
  var _useState3 = (0, _react.useState)(FROM_DEFALUT_TEXT),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showText = _useState4[0],
    setShowText = _useState4[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clear: function clear() {
        setSelectContacts([]);
        setShowText(FROM_DEFALUT_TEXT);
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_["default"], {
    isActive: !!selectContacts.length,
    showText: showText,
    defalutText: FROM_DEFALUT_TEXT
  }, function (_ref) {
    var handleOnToggle = _ref.handleOnToggle;
    return /*#__PURE__*/_react["default"].createElement(_EmailPillInput.EmailPillInput, {
      selectContacts: selectContacts,
      style: {
        width: 400
      },
      getRecipientAvatar: getRecipientAvatar,
      contacts: contacts,
      onSelectChange: function onSelectChange(contacts) {
        setSelectContacts(contacts);
        onSelect(contacts);
        var showText = (0, _.getShowText)(contacts, 'name', {
          defalutText: FROM_DEFALUT_TEXT
        });
        if (contacts.length) {
          setShowText("From ".concat(showText));
        } else {
          setShowText(FROM_DEFALUT_TEXT);
        }
        handleOnToggle();
      }
    });
  });
}
var TO_DEFALUT_TEXT = 'To';
function ToEmailPillItem(props, ref) {
  var contacts = props.contacts,
    getRecipientAvatar = props.getRecipientAvatar,
    onSelect = props.onSelect;
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectContacts = _useState6[0],
    setSelectContacts = _useState6[1];
  var _useState7 = (0, _react.useState)(TO_DEFALUT_TEXT),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    showText = _useState8[0],
    setShowText = _useState8[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clear: function clear() {
        setSelectContacts([]);
        onSelect([]);
        setShowText(TO_DEFALUT_TEXT);
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_["default"], {
    isActive: !!selectContacts.length,
    showText: showText,
    defalutText: TO_DEFALUT_TEXT
  }, function (_ref2) {
    var handleOnToggle = _ref2.handleOnToggle;
    return /*#__PURE__*/_react["default"].createElement(_EmailPillInput.EmailPillInput, {
      selectContacts: selectContacts,
      style: {
        width: 400
      },
      getRecipientAvatar: getRecipientAvatar,
      contacts: contacts,
      onSelectChange: function onSelectChange(contacts) {
        setSelectContacts(contacts);
        onSelect(contacts);
        var showText = (0, _.getShowText)(contacts, 'name', {
          defalutText: TO_DEFALUT_TEXT
        });
        if (contacts.length) {
          setShowText("To ".concat(showText));
        } else {
          setShowText(TO_DEFALUT_TEXT);
        }
        handleOnToggle();
      }
    });
  });
}
var ToEmailPill = exports.ToEmailPill = /*#__PURE__*/(0, _react.forwardRef)(ToEmailPillItem);
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(FromEmailPill);
//# sourceMappingURL=index.js.map